import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FormGroup } from '@angular/forms';
import { ExamReportCreateRequest, ExamReportsClient } from '../../../generated-client/generated-api-client';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ExamReportDataService } from 'src/app/services/data-services/exam-report-data.service';
import { ErrorProcessorService } from '../../../services/error-processor.service';
import {isFormModifiedDataService} from "../../../services/data-services/navigation-data-services";

@Component({
  selector: 'app-exam-report-new',
  templateUrl: './exam-report-new.component.html',
  styleUrls: ['./exam-report-new.component.sass'],
})
export class ExamReportNewComponent implements OnInit {
  constructor(
    private titleService: Title,
    private client: ExamReportsClient,
    private router: Router,
    private toastr: ToastrService,
    private errorProcessorService: ErrorProcessorService,
    private _isFormModifiedDataService: isFormModifiedDataService,
  ) {
    this.titleService.setTitle('Jegyzőkönyv létrehozása');
  }

  ngOnInit(): void {}

  onSubmit(form: FormGroup): void {
    const request: ExamReportCreateRequest = {
      examEndedAtUtc: form.get('examEndedAtUtc')?.value === '' ? null : form.get('examEndedAtUtc')?.value,
      examAddressId: form.get('examAddressId')?.value === '' ? null : form.get('examAddressId')?.value,
      examStartedAtUtc: form.get('examStartedAtUtc')?.value === '' ? null : form.get('examStartedAtUtc')?.value,
      closedAtUtc: form.get('closedAtUtc')?.value === '' ? null : form.get('closedAtUtc')?.value,
      openedAtUtc: form.get('openedAtUtc')?.value === '' ? null : form.get('openedAtUtc')?.value,
      identifier: form.get('identifier')?.value === '' ? null : form.get('identifier')?.value,
      isExamStartAutomatic: form.get('isExamStartAutomatic')?.value,
      isSkipAllow: form.get('isSkipAllow')?.value,
      registerDocuments: form.get('registerDocuments')?.value,
      percentagePrecision: form.get('percentagePrecision')?.value,
    };

    this.client.create(request).subscribe(
      next => {
        this.toastr.success('Jegyzőkönyv sikeresen létrehozva');
        this._isFormModifiedDataService.isFormModified = false;
        this.router.navigate(['/exam-reports', next.entityId, 'exam-report-details']);
      },
      error => this.errorProcessorService.processError(error, true)
    );
  }
}
